import dayjs from 'dayjs';

export function validateEntry(type,value)
{
	let returnString='';
	let expression='';
		switch(type){
			case 'validateName':
				expression = /^[\w\d .##\'\-,()]*$/;
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Names cannot contain special characters.";
						returnString += "\n\tAllowed characters are letters, numbers, underscore, space, period, hashtag, single quote, dash, comma and parentheses.\n"
					}
				}
				return returnString;
				break;
			case 'validateProse':
				expression = /^[\w\d \.,:;@&?!##\-\+/()\''"\r\n<>*=]/;
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Usernames cannot contain special characters.";
						returnString += "\n\tAllowed characters are letters, numbers, underscore, space, period, hashtag, single quote, dash, comma and parentheses.\n"
					}
				}
				return returnString;
				break;
			case 'validateAddress':
				expression = /^[\w\d .#,'\-/]*$/;
				//validate only if the field has data
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Please use a valid address. ";
						returnString += "\n\tAllowed characters are letters, numbers,space, underscore, period, comma, forward slash, hashtag and dash.\n"
					}
				}
				return returnString;
				break;
			case 'validateCity':
				expression = /^[0-9a-zA-Z\s-]{1,255}$/;

				//validate only if the field has data
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Please use a valid city.";
						returnString += "\n\tAllowed characters are numbers, letters, space, tab, linebreak and dash. (Up to 255 characters)\n"
					}
				}
				return returnString;
				break;
			case 'validateState':
				expression =  /^(?:(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY]))$/;
				//validate only if the field has data
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Please use a valid state.";
					}
				}
				return returnString;
				break;
			case 'validateZip':
				expression = /^[0-9]{5}(?:-[0-9]{4})?$/;

				//validate only if the field has data
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Please use a valid zip code.";
					}
				}
				return returnString;
				break;
			case 'validateZipFiveDigitOnly':
				expression = /^\d{5}$/;

				//validate only if the field has data
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Please use a valid 5 digit zip code.";
					}
				}

				return returnString;
				break;
			case 'validateEmail':
			case 'validateConfirmEmail':
				if(value.length) {
					const atIndex = value.indexOf("@");

					if(atIndex > -1) {
						const localPart = value.substring(0, atIndex);
						const domain = value.substring(atIndex + 1);
						const domainEnding = /(\.[a-zA-Z]{2,})$/;

						const validLocalPart = checkDotAtomSyntax(localPart);
						const validDomain = checkDotAtomSyntax(domain);
						const validDomainEnding = domainEnding.test(domain);
						if(!(validLocalPart && validDomain && validDomainEnding)) {
							returnString = "Please enter a valid email.";
						}
					} else {
						returnString = "Please enter a valid email.";
					}
				}
				return returnString;
				break;
			case 'validateDOB':
				let dateObj=new Date(value);
				if (dateObj instanceof Date) {
					let dobmessage='Date of birth must be a valid date in the past.';		
					let today=dayjs().format('YYYY-MM-DD');
					let minor = dayjs().subtract(18,'years');
					let cmpdate=today;
					if(sessionStorage.getItem("DTCADULTONLY") === "On") {
						cmpdate=minor;
						dobmessage = 'Date of birth must be at least 18 years ago.';
					}
					minor=minor.toString();
					if(value.length) {
						if(dayjs(value).isAfter(cmpdate)) {
							returnString = dobmessage
						}
					}
				}else{
					returnString='Date of birth must be a valid date.';
				}
				return returnString;
				break;
			case 'validatePassword':
			     expression = /^((?!.* )((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?!.* )(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&\/=?_.,:;\\-])|(?!.* )(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%&\/=?_.,:;\\-])|(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&\/=?_.,:;\\-]))).{8,}$/
      
				//validate only if the field has data
				if(value.length) {
					if(!expression.test(value)) {
						returnString = "Password does not meet the criteria.";
					}
				}
				return returnString;
			
				break;

			default:
				expression = /[^\w\d .#-]/;
				
				if(value.length) {
					if(expression.test(value)) {
						returnString ="Cannot contain special characters.";
						returnString += "\n\tAllowed characters are letters, numbers, space, underscore, period, hashtag and dash.\n"
					}
				}

				return returnString;
			}
	
}

 function checkDotAtomSyntax(toValidate)
    {
        if(toValidate.length) {
            const dotAtomExpression = /[^\w!#$%&'\*+-/=?^`{}~.]/;
            const startsWithPeriodExpression = /^./;
            const endsWithPeriodExpression = /.$/;
            const consecutivePeriodsExpression = /.{2,}/;
            const unAcceptableCharacters = dotAtomExpression.test(toValidate);
            const leadingPeriod = startsWithPeriodExpression.test(toValidate);
            const consecutivePeriods = consecutivePeriodsExpression.test(toValidate);
            const endingPeriod = endsWithPeriodExpression.test(toValidate);

            return (!(unAcceptableCharacters || !leadingPeriod || !consecutivePeriods || !endingPeriod));
        } else {
            return false;
        }
    }



	
